import React from 'react';
import { CTAButton } from './CTAButton';
const CHECKOUT_URL = 'https://mega-pack-tierraviva.impultienda.ar/checkout';
export const PricingSection: React.FC = () => {
  return <section id="precio" className="bg-[#1A1A1A] py-10 px-4 text-center" data-id="element-180" data-mp="1ei8mjntsfhtk">
      <h2 className="text-[clamp(20px,3.5vw,32px)] text-white mb-1 font-black" data-id="element-181" data-mp="1egxgtigs7zzt">
        ELEGÍ TU <span className="text-green-brand" data-id="element-182" data-mp="1jaibp1n2wdus">MEGA PACK</span>
      </h2>
      <p className="text-[13px] text-[#999] font-sans mb-5" data-id="element-183" data-mp="1nbbzlv0itsno">
        Todo el sistema completo, en un solo pago
      </p>

      <div className="max-w-[550px] mx-auto" data-id="element-184" data-mp="1s82b051ds02r">
        <div id="oferta-master" className="relative rounded-xl py-5 px-4 text-left border-2 border-green-brand bg-[#1e2e1e]" data-id="element-185" data-mp="1x8zsefekgq37">
          <div className="flex justify-center mb-4" data-id="element-186" data-mp="2282vvveweo92">
            <img src="https://cdn.magicpatterns.com/uploads/7HQJK8aZooEaxht83VmJJA/eb3fb1ef-73ad-4646-86eb-9620a5d20949.png" alt="Mega Pack Tierra Viva — trilogía completa con bonos" className="w-full max-w-[280px] h-auto object-contain" data-id="element-187" data-mp="225gtea6v6yxp" />
          </div>
          <div className="flex items-center gap-3" data-id="element-188" data-mp="1mhpz060ob8eq">
            <div className="flex-shrink-0" data-id="element-189" data-mp="1hpy97xpcd6pn">
              <div className="w-5 h-5 rounded-full border-2 border-green-brand flex items-center justify-center" data-id="element-190" data-mp="1howv1kd1443p">
                <div className="w-2.5 h-2.5 rounded-full bg-green-brand" data-id="element-191" data-mp="1crek5ofgbet2" />
              </div>
            </div>
            <div className="flex-1 min-w-0" data-id="element-192" data-mp="17tlgb21mewvy">
              <div className="text-xl leading-none mb-1" data-id="element-193" data-mp="25g2ba0mvsyej">🌿</div>
              <h3 className="text-[15px] text-white font-sans font-bold leading-tight" data-id="element-194" data-mp="25d6eifmrsfro">
                MEGA PACK TIERRA VIVA
              </h3>
              <span className="inline-block bg-green-brand text-[#1A1A1A] text-[10px] font-black font-sans px-2 py-0.5 rounded mt-1 uppercase tracking-wide" data-id="element-195" data-mp="1vgl7xpv3qwlq">
                MÁS ELEGIDO
              </span>
              <p className="text-[12px] text-[#999] font-sans mt-1" data-id="element-196" data-mp="k38z10khjnsp">
                3 Tomos + 3 Bonos Pro
              </p>
              <p className="text-[12px] text-green-brand font-sans font-semibold mt-1" data-id="element-197" data-mp="fzb0os2zih0p">
                Ideal para: Todo autoconstructor que quiere ir del suelo a la
                llave
              </p>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-198" data-mp="mei7dge8dl6g">
              <p className="text-[13px] text-[#777] line-through font-sans" data-id="element-199" data-mp="7isi99dr0rxi">
                $56.000
              </p>
              <div className="text-[clamp(24px,5vw,32px)] font-black leading-none text-green-brand" data-id="element-200" data-mp="cgu1bub6cr8z">
                $15
              </div>
              <p className="text-[11px] text-[#888] font-sans" data-id="element-201" data-mp="3hqi8qc0cbuh">USD</p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Button */}
      <div id="comprar" className="max-w-[550px] mx-auto mt-5" data-id="element-202" data-mp="3l01m5mxqcm04">
        <CTAButton href={CHECKOUT_URL} className="w-full !py-4 !px-6 !text-base" data-id="element-203" data-mp="3pws126xstbjy">
          → QUIERO MI MEGA PACK
        </CTAButton>

        <div className="flex justify-center gap-2 flex-wrap mt-3" data-id="element-204" data-mp="3bybrm88jx6y4">
          <span className="bg-[#2a2a2a] border border-[#444] rounded-md py-1 px-2.5 text-[10px] font-sans text-[#aaa] font-semibold" data-id="element-205" data-mp="3fznck0ghd3zz">
            💳 Tarjeta
          </span>
          <span className="bg-[#2a2a2a] border border-[#444] rounded-md py-1 px-2.5 text-[10px] font-sans text-[#aaa] font-semibold" data-id="element-206" data-mp="2sc9y91p0gmfn">
            📱 Pagas en tu Moneda
          </span>
          <span className="bg-[#2a2a2a] border border-[#444] rounded-md py-1 px-2.5 text-[10px] font-sans text-[#aaa] font-semibold" data-id="element-207" data-mp="369f4b1oq5law">
            🏦 Transferencia
          </span>
        </div>
      </div>

      <p className="text-[12px] text-[#666] font-sans mt-4" data-id="element-208" data-mp="3bavzcgkj2djk">
        🔒 Pago 100% seguro &nbsp;|&nbsp; ⚡ Acceso en 5 minutos &nbsp;|&nbsp;
        🛡️ Garantía 7 días
      </p>
    </section>;
};